// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js!../../../components/library/style/breakpoint.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js!../../../components/library/style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LXEamVEh3IUNpxBsFQzd {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: center;
  width: 25vw;
  margin-left: 15%;

  background-color: white;
  box-shadow: 0px 6px 36px rgba(0, 0, 0, 0.06);
  border-radius: 10px;
  padding: 30px;
  min-height: 460px;
  
  color: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-text"]};
}

.e_W5c5Jv3qjMvhX1v3hB {
  font-weight: bold;
  color: black;
  font-size: 20px;
  margin: 0;
}

.e_W5c5Jv3qjMvhX1v3hB.Kg0509bqMT1BU95sSfWU {
  color: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-purple"]};
  font-size: 22px;
  font-weight: normal;
}

.iPyL1YSNRA6pyZj5Vxz5 {
  height: 200px;
  max-width: 100%;
  margin: 10px auto 10px auto;
}

.DUCQiyiOpjIzjhIyNBDh {
  color: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-text"]};
  font-size: 18px;
  font-weight: bold;
  margin: 0;
  margin-left: 20px;
  margin-right: 20px;
  white-space: pre-line;
}

.bwte9Q858VWzMBajnGBm {
  color: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-text-subtle"]};
  font-size: 16px;
  margin: 0;
  margin-left: 20px;
  margin-right: 20px;
  white-space: pre-line;
}

.fbDgirM7ONTpB21XhKLs {
  display: inline-block;
  width: 100%;
  justify-content: end;
}

.fbDgirM7ONTpB21XhKLs .c8motLLZMYBrQqUOn9V2 {
  color: color-purple-bg;
  background-color: color-purple-bg;
  width: 5px;
  height: 5px;
  margin: 5px;
}

.fbDgirM7ONTpB21XhKLs .c8motLLZMYBrQqUOn9V2.wX5oKym2iR3VZPm7mM5n {
  color: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-purple"]};
  background-color: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-purple"]};
  width: 5px;
  height: 5px;
  margin: 5px;
}

@media screen and (max-width: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet-l"]}) {
  .LXEamVEh3IUNpxBsFQzd {
    width: 90vw;
    margin-left: auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/views/InvoicingForm/WhatNext/WhatNext.module.css"],"names":[],"mappings":"AAMA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;EACX,gBAAgB;;EAEhB,uBAAuB;EACvB,4CAA4C;EAC5C,mBAAmB;EACnB,aAAa;EACb,iBAAiB;;EAEjB,mDAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,SAAS;AACX;;AAEA;EACE,mDAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mDAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mDAAwB;EACxB,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,iCAAiC;EACjC,UAAU;EACV,WAAW;EACX,WAAW;AACb;;AAEA;EACE,mDAAmB;EACnB,8DAA8B;EAC9B,UAAU;EACV,WAAW;EACX,WAAW;AACb;;AAEA;EACE;IACE,WAAW;IACX,iBAAiB;EACnB;AACF","sourcesContent":["@value breakpoints: \"components/library/style/breakpoint.css\";\n@value tablet-l from breakpoints;\n\n@value colors: \"components/library/style/colors.css\";\n@value color-text, color-text-subtle, color-purple from colors;\n\n.flexBox {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  text-align: center;\n  width: 25vw;\n  margin-left: 15%;\n\n  background-color: white;\n  box-shadow: 0px 6px 36px rgba(0, 0, 0, 0.06);\n  border-radius: 10px;\n  padding: 30px;\n  min-height: 460px;\n  \n  color: color-text;\n}\n\n.header {\n  font-weight: bold;\n  color: black;\n  font-size: 20px;\n  margin: 0;\n}\n\n.header.blue {\n  color: color-purple;\n  font-size: 22px;\n  font-weight: normal;\n}\n\n.image {\n  height: 200px;\n  max-width: 100%;\n  margin: 10px auto 10px auto;\n}\n\n.titleSection {\n  color: color-text;\n  font-size: 18px;\n  font-weight: bold;\n  margin: 0;\n  margin-left: 20px;\n  margin-right: 20px;\n  white-space: pre-line;\n}\n\n.descriptionSection {\n  color: color-text-subtle;\n  font-size: 16px;\n  margin: 0;\n  margin-left: 20px;\n  margin-right: 20px;\n  white-space: pre-line;\n}\n\n.buttonSlider {\n  display: inline-block;\n  width: 100%;\n  justify-content: end;\n}\n\n.buttonSlider .checkboxSlider {\n  color: color-purple-bg;\n  background-color: color-purple-bg;\n  width: 5px;\n  height: 5px;\n  margin: 5px;\n}\n\n.buttonSlider .checkboxSlider.checked {\n  color: color-purple;\n  background-color: color-purple;\n  width: 5px;\n  height: 5px;\n  margin: 5px;\n}\n\n@media screen and (max-width: tablet-l) {\n  .flexBox {\n    width: 90vw;\n    margin-left: auto;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"breakpoints": `"components/library/style/breakpoint.css"`,
	"tablet-l": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet-l"]}`,
	"colors": `"components/library/style/colors.css"`,
	"color-text": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-text"]}`,
	"color-text-subtle": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-text-subtle"]}`,
	"color-purple": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-purple"]}`,
	"flexBox": `LXEamVEh3IUNpxBsFQzd`,
	"header": `e_W5c5Jv3qjMvhX1v3hB`,
	"blue": `Kg0509bqMT1BU95sSfWU`,
	"image": `iPyL1YSNRA6pyZj5Vxz5`,
	"titleSection": `DUCQiyiOpjIzjhIyNBDh`,
	"descriptionSection": `bwte9Q858VWzMBajnGBm`,
	"buttonSlider": `fbDgirM7ONTpB21XhKLs`,
	"checkboxSlider": `c8motLLZMYBrQqUOn9V2`,
	"checked": `wX5oKym2iR3VZPm7mM5n`
};
export default ___CSS_LOADER_EXPORT___;
